const equaroDomain = "https://api-staging.eqaroguarantees.com/user/v1";

//Live
const BASE_URL = "https://apis.kipinn.com/";
const BOOKING_URL = "https://book.kipinn.in";

//Development
//const BASE_URL = "http://172.208.33.94:3004/";
//const BASE_URL = "http://20.83.208.91:3001/";
// const BASE_URL = "http://54.196.139.145:3001/";
// const BASE_URL = "https://stagingcallback.kipinn.com/";
// const PROPERTY_SHARE_URL = "http://74.235.207.87:3007/property";
const PROPERTY_SHARE_URL = "https://property.kipinn.in/property";

//const BOOKING_URL = "http://20.9.240.224:3005";


const GetAccessToken = () => {
  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;
  if (user) return user.token;

  return null;
};

const GetUserId = () => {
  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;

  if (user) return user.userId;

  return null;
};

const Config = {
  AxiosConfig: {
    headers: {
      authorization: `${GetAccessToken()}`,
      id: GetUserId(),
    },
  },

  userType: {
    SUPERADMIN: 1,
    MARKETING: 3,
    OPERATION: 2,
  },
  eqaroDomain: equaroDomain,
  domain: BASE_URL,
  apiUrl: BASE_URL + "api",
  certificateUrl: BASE_URL + "api/upload/CERTIFICATES/",
  docUrl: BASE_URL + "api/upload/",
  propertyShareUrl: PROPERTY_SHARE_URL,
  bookingShareUrl: BOOKING_URL,
  sessionExpiredTime: 500, // in minutes
  idleTime: 15, // in mins

  roomTypeMapping: {
    1: "Single sharing",
    2: "Double sharing",
    3: "Triple sharing",
    4: "Three plus sharing",
  },

  roomStatus: {
    1: "Vacant",
    2: "Semi occupied",
    3: "Occupied",
    4: "Inactive",
  },
  FLAT_STATUS: {
    ACTIVE: 1,
    INACTIVE: 2,
  },
  // ROOM_STATUS: {
  //   VACANT: 1,
  //   Semi_Occupied: 2,
  //   Occupied: 3,
  //   Inactive: 4,
  // },
  GENDER_PREFERENCE: {
    MALE: 1,
    FEMALE: 2,
    BOTH: 3,
  },
  PROPERTY_TYPE: {
    PG: 1,
    FLAT: 2,
  },
  TENANT_STATUS: {
    UNVERIFIED: 1,
    VACANT: 2,
    LINKED: 3,
    REQUESTED: 4,
    OCCUPIED: 5,
    MOVING_OUT: 6,
    RESERVED: 7,
  },
  ROOM_TYPES: {
    SINGLE_SHARING: 1,
    DOUBLE_SHARING: 2,
    TRIPLE_SHARING: 3,
    THREE_PLUS_SHARING: 4,
    RK_1: 5,
    BHK_1: 6,
    BHK_2: 7,
    BHK_3: 8,
    BHK_3_PLUS: 9,
  },
  BED_STATUS: {
    VACANT: 1,
    VACANT_RESERVED: 2,
    OCCUPIED: 3,
    MOVING_OUT: 4,
    RESERVED: 5,
    ON_HOLD: 6,
  },
  ROOM_STATUS: {
    VACANT: 1,
    SEMI_OCCUPIED: 2,
    OCCUPIED: 3,
    INACTIVE: 4,
  },

  dueType: {
    RENT: 1,
    SECURITY: 2,
    MAINTENANCE: 3,
    ELECTRICITY: 4,
    REGISTRATION: 5,
    TECH_CHARGES: 6,
    OTHER: 7,
    AGREEMENT_CHARGE: 8,
    FOOD: 9,
    FINE: 10,
    SETTLEMENT: 11,
    WIFI: 12,
    GAS: 13,
    MAID_CHARGES: 14,
    DAMAGE: 15,
    KEY_CHARGES: 16,
    LAUNDRY_CHARGES: 17,
    MOVE_OUT_CHARGES: 19,
    GUEST_CHARGES: 20,
    BUS_CHARGES: 21,
  },

  EXTRA_CHARGE_TYPES: {

    MAINTENANCE: 3,
    ELECTRICITY: 4,
    REGISTRATION: 5,
    TECH_CHARGES: 6,
    OTHER: 7,
    AGREEMENT_CHARGE: 8,
    FOOD: 9,
    FINE: 10,
    WIFI: 12,
    MAID_CHARGES: 14,
    LAUNDRY_CHARGES: 17,
    MOVE_OUT_CHARGES: 19,
    BUS_CHARGES: 21,
  },

  SOURCE: {
    FACEBOOK: 1,
    GOOGLE: 2,
    INSTAGRAM: 3,
    FLATMATE: 4,
    MAGICBRICKS: 5,
    ACRES: 6,
    HOUSING: 7,
    WEBSITE: 8,
    EQARO: 9,
    NOBROKER: 10,
    OLX: 11,
    QUIKR: 12,
    WALKIN: 13,
    OTHERS: 100,
  },
  LEAD_STATUS: {
    NEW: 1,
    FOLLOW_UP: 2,
    VISIT_SCHEDULED: 3,
    VISIT_DONE: 4,
    CONVERTED: 5,
    NOT_INTERESTED: 6,
    CONTACTED: 7,
    INTERESTED: 8,
    INVALID: 9,
    ON_HOLD: 10,
    NOT_ANSWERED: 11,
    LOST: 12,
    STAFF_ASSIGNED: 13,
    MOVED_IN: 14,
    PAID_TOKEN: 15,
  },
  RENT_RANGE: {
    ZERO_TO_FIVE_K: 1,
    FIVE_TO_TEN_K: 2,
    TEN_TO_FIFTEEN_K: 3,
    FIFTEEN_TO_TWENTY_K: 4,
    TWENTY_TO_TWENTY_FIVE_K: 5,
    TWENTY_FIVE_TO_THIRTY_K: 6,
    THIRTY_TO_THIRTY_FIVE_K: 7,
    THIRTY_FIVE_TO_FORTY_K: 8,
    FORTY_TO_FORTY_FIVE_K: 9,
    FORTY_FIVE_TO_FIFTY_K: 10,
    FIFTY_PLUS: 11,
  },
  STAFF_ROLES: {
    ADMIN: 1,
    WARDEN: 2,
    ELECTRICIAN: 3,
    PLUMBER: 4,
    LAUNDRY: 5,
    CARPENTER: 6,
    PARTNER: 7,
    COOK: 8,
    HOUSEKEEPING: 9,
    SALESPERSON: 10,
    SECURITYGUARD: 11,
    FINANCEADMIN: 12,
    BACK_OFFICE: 13,
    HELPDESK: 14,
    BROKER: 15,
    AC_TECH: 16,
    PURIFIER_TECH: 17,
    PAINTER: 18,
    FOOD_VENDOR: 19,
    SALES_HEAD: 20,
    SUPER_ADMIN: 21,
    KITCHEN_MANAGER: 22,
    IT_ADMIN: 23,
    BUS_INCHARGE: 24,
    MAINTENANCE_SUPERVISOR: 25
  },
  USER_TYPE: {
    CLIENT: 1,
    TENANT: 2,
    STAFF: 3,
    VENDOR: 4,
    LANDLORD: 5,
  },
  PLATFORM: {
    ANDROID: 1,
    IOS: 2,
    WEB: 3,
  },

  PERMISSIONS: {
    MANANGE_INVENTORY: 0,
    MANANGE_TENANTS: 1,
    MANANGE_BANKS: 2,
    MANANGE_STAFF: 3,
    MANANGE_DUES: 4,
    MANANGE_EXTRACHARGES: 5,
    MANANGE_EXPENSES: 6,
    MANANGE_LEADS: 7,
    MANANGE_SENDNOTICES: 8,
    MANANGE_ATTENDANCES: 9,
    MANANGE_COLLECTIONS: 10,
    MANANGE_TRANS_RESTORE: 11,
    MANANGE_REQUESTS: 12,
    MANANGE_REPORTS: 13,
    MANANGE_COMPLAINTS: 14,
    MANANGE_LANDLORD: 15,
    MANANGE_PROPERTY_ASSETS: 16,
    MANAGE_STAFF_SALARY: 17,
    MANANGE_EDIT_DUES: 18,
    MANANGE_DELETE_DUES: 19,
    MANANGE_MARK_PAID: 20,
    VIEW_FINANCIAL_SUMMARY: 21,
    MANAGE_STAFF_PERMISSION: 22,
    MANAGE_OTHER_STAFF_ATTENDANCE: 23,
    MANAGE_FOOD: 24,
    MANAGE_DOCUMENTS: 25,
    MANAGE_BUS_SERVICE: 26,
    MANAGE_LAUNDRY: 27,
    MANAGE_INVENTORY: 28,
    MANAGE_VENDOR: 29,
    MANAGE_HOUSEKEEPING: 30,
    MANAGE_OTHER_STAFF_HOUSEKEEPING: 31,
  },

  RENTAL_BOND: {
    NOT_REQUIRED: 1,
    MANDATORY: 2,
  },
  ONLINE_PAYMENT: {
    ENABLED: 1,
    DISABLED: 0,
  },
  OCCUPANCY_STATUS: {
    PENDING: 1,
    REQUESTED: 2,
    OCCUPIED: 3,
    MOVING_OUT: 4,
    RESERVED: 5,
  },
  REQUEST_TYPE: {
    ONBOARDING: 1,
    MOVEOUT: 2,
    REFUND: 3,
    GUEST: 4,
  },
  PROPERTY_STATUS: {
    PENDING: 1,
    COMPLETED: 2,
    ACTIVE: 3,
    INACTIVE: 4,
    DELETED: 5,
  },
  RENTAL_OPTIONS: {
    MONTHLY: 1,
    SHORT_DURATION: 2,
    OTHERS: 3,
  },
  STAY_TYPE: {
    NORMAL: 0,
    LONG: 1,
    SHORT: 2,
  },
  PROPERTY_OWNERSHIP: {
    OWNER: 1,
    CO_OWNER: 2,
    POA: 3,
  },
  LANDLORD_PROPERTY_TYPE: {
    PG: 1,
    APARTMENT: 2,
    VILLA: 3,
    INDEPENDENT_FLOOR: 4
  },
  REQUEST_STATUS: {
    PENDING: 1,
    APPROVED: 2,
    REJECTED: 3,
    CANCELLED: 4,
    INPROGRESS: 5
  },
  COMPLAINT_STATUS: {
    PENDING: 1,
    ASSIGNED: 2,
    RESOLVED: 3,
    REOPENED: 4,
  },
  STAMP_REQUIRED: {
    YES: 1,
    NO: 0,
  },
  PAYOUT_ENABLED: {
    YES: 1,
    NO: 0,
  },
  STAMP_PAPERS_STATUS: {
    AVAILABLE: 1,
    ALLOTTED: 2,
  },
  BENEFICIARY_STATUS: {
    INITIATED: 1,
    VERIFIED: 2,
    FAILED: 3,
    INVALID: 4,
    CANCELLED: 5,
    DELETED: 6,
    INACTIVE: 7,
  },
  PAYOUT_METHOD: {
    IMPS: 1,
    NEFT: 2,
    RTGS: 3,
  },
  TRANSFER_STATUS: {
    INITIATED: 1,
    ACKNOWLEDGED: 2,
    SUCCESS: 3,
    FAILED: 4,
    REVERSED: 5,
    REJECTED: 6
  },
  BENEFICIARY_TYPE: {
    TENANT: 2,
    STAFF: 3,
    VENDOR: 4,
    LANDLORD: 5,
  },
  ASSET_ASSIGNED_TO: {
    TENANT: 1,
    STAFF: 2,
    UNASSIGNED: 3,
  },
  ASSET_INFO_TYPES: {
    VEHICLE_NUMBER: 1,
    RTO_TAX_EXPIRY: 2,
    INSURANCE_EXPIRY: 3,
    PUCC_EXPIRY: 4,
  },
  MEAL_TYPE: {
    BREAKFAST: 1,
    LUNCH: 2,
    SNACKS: 3,
    DINNER: 4,
  },
  DIET_PREFERENCE: {
    VEG: 1,
    NON_VEG: 2,
  },
  MEAL_CONSUMPTION_STATUS: {
    PENDING: 1,
    CONSUMED: 2,
    SKIPPED: 3,
  },
  REFUND_STATUS: {
    PENDING: 0,
    STATEMENT_GENERATED: 1,
    PROCESSED: 2,
    FORFEITED: 3,
    INITIATED: 4,
  },
  BOOKING_STATUS: {
    LINK_SENT: 0,
    FORM_SUBMITTED: 1,
    PAYMENT_DONE: 2,
    CONFIRMED: 3,
    CANCELLED: 4,
    MOVED_IN: 5,
  },
  // Constants for food item categories
  FOOD_ITEM_CATEGORY: {
    GRAINS: 1,
    PULSES: 2,
    VEGETABLES: 3,
    FRUITS: 4,
    EGGS_DAIRY: 5,
    OIL_GHEE: 6,
    SPICES: 7,
    TEA_COFFEE: 9,
    MEAT_SEAFOOD: 10,
    SNACKS: 11,
    SWEETENERS: 12,
    BAKING: 13,
    CLEANING: 14,
    PACKAGING: 15,
    KITCHEN: 16,
    OTHERS: 50,
  },
  // Constants for inventory units
  INVENTORY_UNIT: {
    KG: 1,
    GRAM: 2,
    LITRE: 3,
    ML: 4,
    PIECE: 5,
    PACKET: 6,
    BOTTLE: 7,
    BOX: 8,
    DOZEN: 9,
    BAG: 10,
    CARAT: 11
  },
  WEB_DASHBOARD_TYPES: {
    MAIN: 1,
    SALES: 2,
    KITCHEN: 3,
  },
  WALLET_STATUS: {
    ACTIVE: 1,
    DEACTIVATED: 2,
  },
  AUTOPAY_QUEUE_STATUS: {
    PENDING: 0,
    SUCCESS: 1,
    FAILED: 2,
    CANCELLED: 3,
    IN_PROGRESS: 4,
    REVERSED: 5,
    ERROR: 6,
  },
  AUTOPAY_STATUS: {
    ACTIVE: 1,
    PAUSED: 2,
    CANCELLED: 3,
    COMPLETED: 4,
  },
  MOVE_OUT_STATUS: {
    INITIATED: 1,
    MOVEOUT: 2,
  },
};

export const rentRange = [
  { value: Config.RENT_RANGE.ZERO_TO_FIVE_K, label: "0-5K" },
  { value: Config.RENT_RANGE.FIVE_TO_TEN_K, label: "5K-10K" },
  { value: Config.RENT_RANGE.TEN_TO_FIFTEEN_K, label: "10K-15K" },
  { value: Config.RENT_RANGE.FIFTEEN_TO_TWENTY_K, label: "15K-20K" },
  { value: Config.RENT_RANGE.TWENTY_TO_TWENTY_FIVE_K, label: "20K-25K" },
  { value: Config.RENT_RANGE.TWENTY_FIVE_TO_THIRTY_K, label: "25K-30K" },
  { value: Config.RENT_RANGE.THIRTY_TO_THIRTY_FIVE_K, label: "30K-35K" },
  { value: Config.RENT_RANGE.TWENTY_FIVE_TO_THIRTY_K, label: "35K-40K" },
  { value: Config.RENT_RANGE.FORTY_TO_FORTY_FIVE_K, label: "40K-45K" },
  { value: Config.RENT_RANGE.FORTY_FIVE_TO_FIFTY_K, label: "45K-50K" },
  { value: Config.RENT_RANGE.FIFTY_PLUS, label: "50K+" },
];

// export const leadStatus = [
//   { value: Config.LEAD_STATUS.NEW, label: "New" },
//   { value: Config.LEAD_STATUS.FOLLOW_UP, label: "Follow Up" },
//   { value: Config.LEAD_STATUS.VISIT_SCHEDULED, label: "Visit Scheduled" },
//   { value: Config.LEAD_STATUS.VISIT_DONE, label: "Visit Done" },
//   { value: Config.LEAD_STATUS.CONVERTED, label: "Converted" },
//   { value: Config.LEAD_STATUS.NOT_INTERESTED, label: "Not Interesed" },
// ];

export const dueTypes = [
  { value: Config.dueType.RENT, label: "Rent" },
  { value: Config.dueType.SECURITY, label: "Security" },
  { value: Config.dueType.MAINTENANCE, label: "Maintenance" },
  { value: Config.dueType.ELECTRICITY, label: "Electricity" },
  { value: Config.dueType.REGISTRATION, label: "Registration" },
  { value: Config.dueType.TECH_CHARGES, label: "Tech Charges" },
  // { value: 7, label: "Other" },
  { value: Config.dueType.AGREEMENT_CHARGE, label: "Agreement Charges" },
  { value: Config.dueType.FOOD, label: "Food Charges" },
  { value: Config.dueType.FINE, label: "Fine" },
  { value: Config.dueType.WIFI, label: 'Wifi Bill' },
  { value: Config.dueType.GAS, label: 'Gas Bill' },
  { value: Config.dueType.MAID_CHARGES, label: 'Maid Charges' },
  { value: Config.dueType.DAMAGE, label: 'Damage Charges' },
  { value: Config.dueType.KEY_CHARGES, label: 'Key Loss Charges' },
  { value: Config.dueType.LAUNDRY_CHARGES, label: 'Laundry Bill' },
  { value: Config.dueType.MOVE_OUT_CHARGES, label: 'MoveOut Charges' },
  { value: Config.dueType.GUEST_CHARGES, label: 'Guest Charges' },
  { value: Config.dueType.BUS_CHARGES, label: 'Bus Charges' },
];
export const addDuesTypesForExtendStay = [
  { value: Config.dueType.ELECTRICITY, label: "Electricity Bill" },
  { value: Config.dueType.MAINTENANCE, label: "Maintenance Charge" },
  { value: Config.dueType.REGISTRATION, label: "Registration Charge" },
  { value: Config.dueType.FOOD, label: "Food Bill" },
  { value: Config.dueType.OTHER, label: "Other" },
];
export const availableAmenities = [
  { label: "Balcony", value: "Balcony" },
  { label: "AC", value: "AC" },
  { label: "TV", value: "TV" },
  { label: "Attached Bathroom", value: "Attached Bathroom" },
  { label: "Wi-Fi", value: "Wi-Fi" },
  { label: "Washing Machine", value: "Washing Machine" },
  { label: "Cooler", value: "Cooler" },
  { label: "Geyser", value: "Geyser" },
  { label: "Attached Kitchen", value: "Attached Kitchen" },
  { label: "Fridge", value: "Fridge" },
  { label: "Microwave", value: "Microwave" },
  { label: "Almirah", value: "Almirah" },
  { label: "Induction", value: "Induction" },
  { label: "Study Table", value: "Study Table" },
];
export const assetAssignTo = [
  { value: 1, label: "Tenant" },
  { value: 2, label: "Staff" },
  { value: 3, label: "Unassigned" },
];
export const alertType = [
  { value: 2, label: "RTO/Tax" },
  { value: 3, label: "Insurance" },
  { value: 4, label: "PUCC" },
];
export const assetAssignStatus = [
  { value: 1, label: "Active" },
  { value: 2, label: "In Maintenance" },
  { value: 3, label: "Disposed" },
  { value: 4, label: "In Use" },
];
export const PaginationLimit = 10;

export const plans = [
  { value: 1, label: "Bronze" },
  { value: 2, label: "Silver" },
  { value: 3, label: "Gold" },
];

export const ForUs = (userId) => {
  if (userId === "e9ca6870-e80a-4df1-9b27-b6986fd6244a") {
    return true;
  }

  return false;
};

export const gTypeOfRoles = [
  { value: "1", label: "Registrar" },
  { value: "2", label: "Customers" },
  { value: "3", label: "Subadmins" },
  { value: "4", label: "Reports" },
];

export const acReadingBy = [
  { value: 1, label: "Room" },
  { value: 2, label: "Tenant" },
];

export const staff_roles = [
  { label: "Admin", value: Config.STAFF_ROLES.ADMIN },
  { label: "Partner", value: Config.STAFF_ROLES.PARTNER },
  {
    label: "Warden",
    value: Config.STAFF_ROLES.WARDEN,
  },
  { label: 'Sales Head', value: Config.STAFF_ROLES.SALES_HEAD },
  { label: "Sales Person", value: Config.STAFF_ROLES.SALESPERSON },
  { label: "Plumber", value: Config.STAFF_ROLES.PLUMBER },
  { label: "Electrician", value: Config.STAFF_ROLES.ELECTRICIAN },
  { label: "Laundry", value: Config.STAFF_ROLES.LAUNDRY },
  { label: "Carpenter", value: Config.STAFF_ROLES.CARPENTER },
  { label: "Cook", value: Config.STAFF_ROLES.COOK },
  { label: "Kitchen Manager", value: Config.STAFF_ROLES.KITCHEN_MANAGER },
  { label: "IT Admin", value: Config.STAFF_ROLES.IT_ADMIN },
  { label: "House Keeping", value: Config.STAFF_ROLES.HOUSEKEEPING },
  { label: "Security Guard", value: Config.STAFF_ROLES.SECURITYGUARD },
  { label: "Finance Admin", value: Config.STAFF_ROLES.FINANCEADMIN },
  { label: "Back Office", value: Config.STAFF_ROLES.BACK_OFFICE },
  { label: "Help Desk", value: Config.STAFF_ROLES.HELPDESK },
  { label: 'Broker', value: Config.STAFF_ROLES.BROKER },
  { label: 'AC Tech', value: Config.STAFF_ROLES.AC_TECH },
  { label: 'Purifier Tech', value: Config.STAFF_ROLES.PURIFIER_TECH },
  { label: 'Painter', value: Config.STAFF_ROLES.PAINTER },
  { label: 'Food Vendor', value: Config.STAFF_ROLES.FOOD_VENDOR },
  { label: 'Bus Incharge', value: Config.STAFF_ROLES.BUS_INCHARGE },
  { label: 'Maintenance Supervisor', value: Config.STAFF_ROLES.MAINTENANCE_SUPERVISOR },
  // { label: 'Super Admin', value: Config.STAFF_ROLES.SUPER_ADMIN },
];

export const ownership_roles = [
  { label: "Owner", value: Config.PROPERTY_OWNERSHIP.OWNER },
  { label: "Co-Owner", value: Config.PROPERTY_OWNERSHIP.CO_OWNER },
  {
    label: "POA",
    value: Config.PROPERTY_OWNERSHIP.POA,
  },
];
export const landlord_property_type = [
  { label: "PG", value: Config.LANDLORD_PROPERTY_TYPE.PG },
  { label: "VILLA", value: Config.LANDLORD_PROPERTY_TYPE.VILLA },
  {
    label: "APARTMENT",
    value: Config.LANDLORD_PROPERTY_TYPE.APARTMENT,
  },
  {
    label: "INDEPENDENT FLOOR",
    value: Config.LANDLORD_PROPERTY_TYPE.INDEPENDENT_FLOOR,
  },
];
// export const moveOutReasons = [
//   { label: "Job Transfer / Relocation", value: "relocation" },
//   { label: "Moving Closer to Workplace / College", value: "closer_to_work" },
//   { label: "Found Better Accommodation", value: "better_accommodation" },
//   { label: "End of Lease / Contract", value: "end_of_lease" },
//   { label: "Personal Reasons / Family Emergency", value: "personal_reasons" },
//   { label: "Cost / Rent Too High", value: "high_rent" },
//   { label: "Issues with Flatmates", value: "flatmate_issues" },
//   { label: "Unsatisfactory Maintenance / Services", value: "poor_services" },
//   { label: "Change in Financial Situation", value: "financial_change" },
//   { label: "Purchased Own Property", value: "own_property" },
//   { label: "Temporary Stay Completed", value: "temporary_stay" },
//   { label: "Property Owner Requested Move", value: "owner_request" },
//   { label: "Safety / Security Concerns", value: "safety_concerns" },
//   { label: "Shifted to Native City", value: "native_city" },
//   { label: "Migrating Abroad", value: "migrating_abroad" },
//   // { label: "Other (please specify)", value: "other" }
// ];

export const moveOutReasons = [
  { label: "Job Transfer / Relocation", value: "relocation" },
  { label: "Non-Payment or Consistent Delays in Rent", value: "non_payment" },
  { label: "Violation of Lease or Rental Agreement Terms", value: "violation" },
  { label: "Moving Closer to Workplace / College", value: "closer_to_work" },
  { label: "Found Better Accommodation", value: "better_accommodation" },
  { label: "End of Lease / Contract", value: "end_of_lease" },
  { label: "Personal Reasons / Family Emergency", value: "personal_reasons" },
  { label: "Cost / Rent Too High", value: "high_rent" },
  { label: "Issues with Flatmates", value: "flatmate_issues" },
  { label: "Unsatisfactory Maintenance / Services", value: "poor_services" },
  { label: "Engaging in illegal Activities", value: "illegal_activities" },
  { label: "Change in Financial Situation", value: "financial_change" },
  { label: "Purchased Own Property", value: "own_property" },
  { label: "Temporary Stay Completed", value: "temporary_stay" },
  { label: "Property Owner Requested Move", value: "owner_request" },
  { label: "Safety / Security Concerns", value: "safety_concerns" },
  { label: "Shifted to Native City", value: "native_city" },
  { label: "Migrating Abroad", value: "migrating_abroad" },
  // { label: "Other (please specify)", value: "other" }
];
export const media_types = [
  { value: 1, label: 'Bedroom' },
  { value: 2, label: 'Bathroom' },
  { value: 3, label: 'Kitchen' },
  { value: 4, label: 'Hall' },
  { value: 5, label: 'Outside' },
  { value: 6, label: 'Locality' },
];

export const beneficiaryStatusWithStyle = [
  {
    value: Config.BENEFICIARY_STATUS.INITIATED,
    label: "Initiated",
    color: "text-yellow-700",
    dotColor: "bg-yellow-500"
  },
  {
    value: Config.BENEFICIARY_STATUS.VERIFIED,
    label: "Active",
    color: "text-green-700",
    dotColor: "bg-green-500"
  },
  {
    value: Config.BENEFICIARY_STATUS.FAILED,
    label: "Failed",
    color: "text-red-700",
    dotColor: "bg-red-500"
  },
  {
    value: Config.BENEFICIARY_STATUS.INVALID,
    label: "Invalid",
    color: "text-orange-700",
    dotColor: "bg-orange-500"
  },
  {
    value: Config.BENEFICIARY_STATUS.CANCELLED,
    label: "Cancelled",
    color: "text-gray-700",
    dotColor: "bg-gray-500"
  },
  {
    value: Config.BENEFICIARY_STATUS.DELETED,
    label: "Deleted",
    color: "text-gray-700",
    dotColor: "bg-gray-500"
  },
  {
    value: Config.BENEFICIARY_STATUS.INACTIVE,
    label: "Inactive",
    color: "text-rose-700",
    dotColor: "bg-rose-500",
  },
];

export const tranfer_payment_method = [
  { label: "IMPS", value: Config.PAYOUT_METHOD.IMPS },
  { label: "NEFT", value: Config.PAYOUT_METHOD.NEFT },
  {
    label: "RTGS",
    value: Config.PAYOUT_METHOD.RTGS,
  },
];
export const transferStatusWithStyle = [
  {
    value: Config.TRANSFER_STATUS.INITIATED,
    label: "Initiated",
    color: "bg-yellow-100 text-yellow-700 border-yellow-200",
    dotColor: "bg-yellow-500"
  },
  {
    value: Config.TRANSFER_STATUS.SUCCESS,
    label: "Success",
    color: "bg-green-100 text-green-700 border-green-200",
    dotColor: "bg-green-500"
  },
  {
    value: Config.TRANSFER_STATUS.FAILED,
    label: "Failed",
    color: "bg-red-100 text-red-700 border-red-200",
    dotColor: "bg-red-500"
  },
  {
    value: Config.TRANSFER_STATUS.REVERSED,
    label: "Reversed",
    color: "bg-red-100 text-red-700 border-red-200",
    dotColor: "bg-red-500"
  },
  {
    value: Config.TRANSFER_STATUS.REJECTED,
    label: "Rejected",
    color: "bg-red-100 text-red-700 border-red-200",
    dotColor: "bg-red-500"
  },
  {
    value: Config.TRANSFER_STATUS.ACKNOWLEDGED,
    label: "Acknowleged",
    color: "bg-yellow-100 text-yellow-700 border-yellow-200",
    dotColor: "bg-yellow-500"
  },
];
export const beneficiary_type_roles = [
  // { label: "Tenant", value: Config.BENEFICIARY_TYPE.TENANT },
  { label: "Staff", value: Config.BENEFICIARY_TYPE.STAFF },
  {
    label: "Vendor",
    value: Config.BENEFICIARY_TYPE.VENDOR,
  },
  {
    label: "Landlord",
    value: Config.BENEFICIARY_TYPE.LANDLORD,
  },
];

export const leadStatusConfig = {
  [Config.LEAD_STATUS.NEW]: {
    label: "New",
    color: "text-blue-500",
  },
  [Config.LEAD_STATUS.FOLLOW_UP]: {
    label: "Follow Up",
    color: "text-yellow-500",
    showVisitDate: true,
  },
  [Config.LEAD_STATUS.VISIT_SCHEDULED]: {
    label: "Visit Scheduled",
    color: "text-indigo-500",
    showVisitDate: true,
  },
  [Config.LEAD_STATUS.VISIT_DONE]: {
    label: "Visit Done",
    color: "text-purple-500",
    showVisitDate: true,
  },
  [Config.LEAD_STATUS.CONVERTED]: {
    label: "Converted",
    color: "text-emerald-600",
  },
  [Config.LEAD_STATUS.PAID_TOKEN]: {
    label: "Token Paid",
    color: "text-green-600",
  },
  [Config.LEAD_STATUS.CONFIRMED]: {
    label: "Confirmed",
    color: "text-green-600",
  },
  [Config.LEAD_STATUS.INTERESTED]: {
    label: "Interested",
    color: "text-lime-600",
  },
  [Config.LEAD_STATUS.CONTACTED]: {
    label: "Contacted",
    color: "text-amber-500",
  },
  [Config.LEAD_STATUS.ON_HOLD]: {
    label: "On Hold",
    color: "text-orange-500",
  },
  [Config.LEAD_STATUS.NOT_ANSWERED]: {
    label: "Not Answered",
    color: "text-slate-500",
  },
  [Config.LEAD_STATUS.NOT_INTERESTED]: {
    label: "Not Interested",
    color: "text-gray-500",
  },
  [Config.LEAD_STATUS.INVALID]: {
    label: "Invalid",
    color: "text-rose-500",
  },
  [Config.LEAD_STATUS.LOST]: {
    label: "Lost",
    color: "text-red-600",
  },
};

export const autoPayStatusConfig = {
  [Config.AUTOPAY_STATUS.ACTIVE]: {
    label: "Active",
    color: "text-green-600",
  },
  [Config.AUTOPAY_STATUS.PAUSED]: {
    label: "Paused",
    color: "text-yellow-600",
  },
  [Config.AUTOPAY_STATUS.CANCELLED]: {
    label: "Cancelled",
    color: "text-red-600",
  },
  [Config.AUTOPAY_STATUS.COMPLETED]: {
    label: "Completed",
    color: "text-primary-color",
  },
};

export const source = [
  { value: Config.SOURCE.FACEBOOK, label: 'Facebook' },
  { value: Config.SOURCE.GOOGLE, label: 'Google' },
  { value: Config.SOURCE.INSTAGRAM, label: 'Instagram' },
  { value: Config.SOURCE.FLATMATE, label: 'Flatmate.in' },
  { value: Config.SOURCE.WALKIN, label: 'Walk In' },
  { value: Config.SOURCE.WEBSITE, label: 'Website' },
  { value: Config.SOURCE.MAGICBRICKS, label: 'MagicBricks' },
  { value: Config.SOURCE.ACRES, label: '99acres' },
  { value: Config.SOURCE.HOUSING, label: 'Housing' },
  { value: Config.SOURCE.NOBROKER, label: 'NoBroker' },
  { value: Config.SOURCE.OLX, label: 'Olx' },
  { value: Config.SOURCE.QUIKR, label: 'Quikr' },
  { value: Config.SOURCE.OTHERS, label: 'Others' },
];

export const foodItemCategories = [
  { value: Config.FOOD_ITEM_CATEGORY.GRAINS, label: 'Grains' },
  { value: Config.FOOD_ITEM_CATEGORY.PULSES, label: 'Pulses' },
  { value: Config.FOOD_ITEM_CATEGORY.VEGETABLES, label: 'Vegetables' },
  { value: Config.FOOD_ITEM_CATEGORY.FRUITS, label: 'Fruits' },
  { value: Config.FOOD_ITEM_CATEGORY.EGGS_DAIRY, label: 'Eggs & Dairy' },
  { value: Config.FOOD_ITEM_CATEGORY.OIL_GHEE, label: 'Oil & Ghee' },
  { value: Config.FOOD_ITEM_CATEGORY.SPICES, label: 'Spices' },
  { value: Config.FOOD_ITEM_CATEGORY.TEA_COFFEE, label: 'Tea & Coffee' },
  { value: Config.FOOD_ITEM_CATEGORY.MEAT_SEAFOOD, label: 'Meat & Sea Food' },
  { value: Config.FOOD_ITEM_CATEGORY.SNACKS, label: 'Snacks' },
  { value: Config.FOOD_ITEM_CATEGORY.SWEETENERS, label: 'Sweeteners' },
  { value: Config.FOOD_ITEM_CATEGORY.BAKING, label: 'Baking' },
  { value: Config.FOOD_ITEM_CATEGORY.CLEANING, label: 'Cleaning' },
  { value: Config.FOOD_ITEM_CATEGORY.PACKAGING, label: 'Packaging' },
  { value: Config.FOOD_ITEM_CATEGORY.KITCHEN, label: 'Kitchen' },
  { value: Config.FOOD_ITEM_CATEGORY.OTHERS, label: 'Others' },
];

export const inventoryUnits = [
  { value: Config.INVENTORY_UNIT.KG, label: 'Kg' },
  { value: Config.INVENTORY_UNIT.GRAM, label: 'Gram' },
  { value: Config.INVENTORY_UNIT.LITRE, label: 'Litre' },
  { value: Config.INVENTORY_UNIT.ML, label: 'Ml' },
  { value: Config.INVENTORY_UNIT.PIECE, label: 'Piece' },
  { value: Config.INVENTORY_UNIT.PACKET, label: 'Packet' },
  { value: Config.INVENTORY_UNIT.BOTTLE, label: 'Bottle' },
  { value: Config.INVENTORY_UNIT.BOX, label: 'Box' },
  { value: Config.INVENTORY_UNIT.DOZEN, label: 'Dozen' },
  { value: Config.INVENTORY_UNIT.BAG, label: 'Bag' },
  { value: Config.INVENTORY_UNIT.CARAT, label: 'Carat' },
];

export const autoPayQueueStatuses = [
  { value: Config.AUTOPAY_QUEUE_STATUS.PENDING, label: 'Pending' },
  { value: Config.AUTOPAY_QUEUE_STATUS.SUCCESS, label: 'Success' },
  { value: Config.AUTOPAY_QUEUE_STATUS.FAILED, label: 'Failed' },
  { value: Config.AUTOPAY_QUEUE_STATUS.ERROR, label: 'Failed' },
  { value: Config.AUTOPAY_QUEUE_STATUS.CANCELLED, label: 'Cancelled' },
  { value: Config.AUTOPAY_QUEUE_STATUS.IN_PROGRESS, label: 'In Progress' },
  { value: Config.AUTOPAY_QUEUE_STATUS.REVERSED, label: 'Reversed' },
];

export const autoPayStatuses = [
  { value: Config.AUTOPAY_STATUS.ACTIVE, label: 'Active' },
  { value: Config.AUTOPAY_STATUS.PAUSED, label: 'Paused' },
  { value: Config.AUTOPAY_STATUS.CANCELLED, label: 'Cancelled' },
  { value: Config.AUTOPAY_STATUS.COMPLETED, label: 'Completed' },
];

export const getUserRoleName = (value) => {
  const roles = {
    1: 'Client',
    2: 'Tenant',
    3: 'Staff',
    4: 'Vendor',
    5: 'Landlord',
  };

  return roles[value] || '';
};
export default Config;
